.table {
  width: 100%;
  border-collapse: collapse;
}

.cell {
  padding: 6px 12px;
  border-bottom: 1px solid var(--tuna-palette-divider);
  vertical-align: middle;
}

.headerCell {
  padding: 6px 12px;
  border-bottom: 1px solid var(--tuna-palette-divider);
  vertical-align: middle;
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--tuna-palette-text-secondary);
  text-align: left;
  background-color: var(--tuna-palette-background-default);
}

.actionsCell {
  padding: 6px 12px;
  border-bottom: 1px solid var(--tuna-palette-divider);
  vertical-align: middle;
  white-space: nowrap;
}

.actionsHeaderCell {
  padding: 6px 12px;
  border-bottom: 1px solid var(--tuna-palette-divider);
  vertical-align: middle;
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--tuna-palette-text-secondary);
  text-align: left;
  background-color: var(--tuna-palette-background-default);
  width: 100px;
}

.input {
  font: inherit;
  padding: 4px 8px;
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-radius-sm);
  background-color: var(--tuna-palette-background-paper);
  color: var(--tuna-palette-text-primary, inherit);
  width: 100%;
  box-sizing: border-box;
}

.emptyCell {
  padding: 6px 12px;
  border-bottom: 1px solid var(--tuna-palette-divider);
  vertical-align: middle;
  text-align: center;
  color: var(--tuna-palette-text-secondary);
}
